import { useContext, useState } from "react";
import axios from "./axios";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { RmcContext } from "../components/context/RmcContext";

export const useDeductFee = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [fee, setFee] = useState(null);
  const [show, setShow] = useState(null);
  const [insufficient, setInsufficient] = useState(false);
  const { slug } = useContext(RmcContext);
  const handelDeuctfee = async (id, triviaId) => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        "/audiences/wallet/deduct-fee",
        JSON.stringify({
          game_fee: fee,
        })
      );
      if (response.status === 200) {
        setIsLoading(false);
        navigate(`/worlds/${slug}/questions?id=${id}&trivia_id=${triviaId}`);
      }
    } catch (err) {
      setIsLoading(false);
      if (err?.response?.data?.message === "insufficient funds") {
        setShow(false);
        setInsufficient(true);
      } else toast.error(err?.response?.data?.message);
    }
  };
  return {
    setFee,
    handelDeuctfee,
    isLoading,
    insufficient,
    setInsufficient,
    show,
    setShow,
  };
};
